import React from 'react';

export const genericMemo: <T>(c: T) => T = React.memo;
